import { SocialIcons } from "@/components/shared/SocialIcons";
import { motion } from "framer-motion";

export function SocialConnectSection() {
  return (
    <section className="py-12 bg-muted/30">
      <div className="container">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="text-center"
        >
          <h2 className="text-xl font-bold text-foreground mb-2">Stay Connected</h2>
          <p className="text-sm text-muted-foreground mb-6">Follow us for project ideas, product updates & exclusive offers.</p>
          <SocialIcons
            showLabels
            className="justify-center"
            iconClassName="h-5 w-5"
            gap="gap-6"
          />
        </motion.div>
      </div>
    </section>
  );
}
